import { render } from "./RecepcionEquipoList.vue?vue&type=template&id=3aa38ae8&scoped=true"
import script from "./RecepcionEquipoList.vue?vue&type=script&lang=js"
export * from "./RecepcionEquipoList.vue?vue&type=script&lang=js"

import "./RecepcionEquipoList.vue?vue&type=style&index=0&id=3aa38ae8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa38ae8"]])

export default __exports__